import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setRedirectPath} from "../../modules/actions/authActions";
import {addToCart, getCart} from "../../modules/actions/cartActions";
import {addFlashMessage} from "../../modules/actions/flashMessages.js";
import {Link, withRouter} from "react-router-dom";
import qs from "qs";
import {format} from "../../modules/utils";
import { addActiveDeviceRequest, validateDevice } from "../../modules/actions/productActions";
//import InputMask from 'react-input-mask';
import MaskedInput from 'react-text-mask'
import NotificationAlert from "react-notification-alert";
import ReCAPTCHA from "react-google-recaptcha";

class ActiveDeviceRequestController extends React.Component{

    recaptchaRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            purchasedStore: "Amazon",
            select : "AND",
            useType : "USA",
            startDate : moment(),
            validateDeviceError : false,
            validateOrderError : false,
            imeiError : false,
            orderIdError : false,
            useTypeError : false,
            showUseType : false,
            showUseType1 : false,
            showUseType2 : false,
            country : "",
            productType : "",
            productName : "",
            planDays : "",
            showContinue : true,
            showActivate : false,
            updatedAt : moment().format("MM/DD/YYYY"),
            createdAt : moment().format("MM/DD/YYYY"),
            requestSubmitted : false,
            showingAlert: false,
            isHuman: false,
            humanKey: null
        };
    }

    handleClickShowAlert() {
        this.setState({
            showingAlert: true
        });

        setTimeout(() => {
            this.setState({
                showingAlert: false
            });
        }, 2000);
    }

    setPurchasedStore(purchasedStore) {
        this.setState({
            purchasedStore : purchasedStore
        });
    }

    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    _onChange = event => {
        const field = event.target.name;
        const value = event.target.value;

        //console.log("field " + field + " , value " + value);

        this.setState({ [field]: value });

        if(field == 'orderId' || field == 'imei') {
            this.setState({ "select": "AND" });
            this.setState({ "showContinue": true });
            this.setState({ "showUseType": false });
            this.setState({ "showStartDate": false });
            this.setState({ "showActivate": false });
        }
    };

    onStartDateChange = date => {
        this.setState({
            startDate : date
        });
    };

    setUseType(useType){
        /*if(this.state.useType == "ALL") {
            if(useType == "USA") {
                useType = "GLOBAL";
            }
            else if(useType == "GLOBAL") {
                useType = "USA";
            }
        }
        if(this.state.useType == "USA") {
            if(useType == "USA") {
                useType = null;
            }
            else if(useType == "GLOBAL" && this.state.select == "AND") {
                useType = "ALL";
            }
        }
        if(this.state.useType == "GLOBAL") {
            if(useType == "USA" && this.state.select == "AND") {
                useType = "ALL";
            }
            else if(useType == "GLOBAL") {
                useType = null;
            }
        }*/
        this.setState({
            useType: useType
        })
    }

    validateForm(isActivate){
        let imeiError = false;
        let orderIdError = false;
        let useTypeError = false;

        if (typeof this.state.imei === "undefined" || this.state.imei == ""){
            imeiError = true;
        }

        if (typeof this.state.orderId === "undefined" || this.state.orderId == ""){
            orderIdError = true;
        }

        if(!isActivate) {
            this.setState({
                imeiError: imeiError,
                orderIdError: orderIdError,
            });

            return !(imeiError === true || orderIdError === true);
        }
        else {
            if (typeof this.state.useType === "undefined" || this.state.useType == null || this.state.useType == "") {
                useTypeError = true;
            }

            this.setState({
                imeiError: imeiError,
                orderIdError: orderIdError,
                useTypeError: useTypeError,
            });

            return !(imeiError === true || orderIdError === true || useTypeError === true);
        }
    }

    validateDevice = () => {

        this.setState({
            validateDeviceError: false,
            validateOrderError: false
        })

        if (this.validateForm(false) && this.state.isHuman){
            let user = null;
            if(this.props.auth.isAuthenticated === true){
                user = this.props.auth.user.user;
            }

            let { imei, orderId, purchasedStore, useType, startDate, updatedAt, createdAt } = this.state;
            let payload = {
                imei : imei,
                orderId : orderId,
                purchasedStore : purchasedStore,
                useType : useType,
                startDate : startDate,
                user : user,
                createdAt : createdAt,
                updatedAt : updatedAt
            };

            this.props.validateDevice({
                imei : imei,
                orderId : orderId,
                purchasedStore : purchasedStore,
                humanKey: this.state.humanKey
            }).then(
                res => {
                    if (res.status/* &&
                        typeof res.device !== "undefined" && typeof res.device._id !== "undefined" &&
                        typeof res.order !== "undefined" && typeof res.order._id !== "undefined"*/){
                        this.setState({ "useType": res.useType });
                        this.setState({ "select": res.select });
                        this.setState({ "planDays": res.planDays });
                        this.setState({ "showContinue": false });
                        this.setState({ "showStartDate": true });
                        this.setState({ "showActivate": true });
                        if (res.select === 'NO') {
                            this.setState({ "country": res.country });
                            this.setState({ "productType": res.productType });
                            this.setState({ "productName": res.productName });
                            if (res.startDate && res.startDate !== '') {
                                var startDate = moment(res.startDate + " 00:00:00", "YYYY-MM-DDTHH:mm:ss");
                                /*if (moment(res.startDate).isBefore(moment())) {
                                    res.startDate = new Date().toISOString();
                                }*/
                                this.setState({ "startDate": startDate });
                            }
                        }
                        else {
                            this.setState({ "showUseType": true });
                            this.setState({ "showUseType1": res.useType1 });
                            this.setState({ "showUseType2": res.useType2 });
                        }
                    }
                    else{
                        this.setState({ "useType": "" });
                        this.setState({ "startDate": moment() });
                        this.setState({ "showContinue": true });
                        this.setState({ "showUseType": false });
                        this.setState({ "showStartDate": false });
                        this.setState({ "showActivate": false });

                        if(!res.order) {
                            this.setState({
                                validateOrderError: true
                            });
                        }
                        else if(!res.device) {
                            this.setState({
                                validateDeviceError: true
                            });
                        }
                        else {
                            this.showMessage("Your device has already been activated.");
                        }
                    }

                    this.recaptchaRef.current.reset();
                    this.setState({isHuman: false, humanKey: null});
                },
                err => {
                    this.setState({
                        validateOrderError: true,
                        validateDeviceError : true
                    })

                    this.recaptchaRef.current.reset();
                    this.setState({isHuman: false, humanKey: null});
                }
            );
        }
    };

    saveActiveDeviceRequest = () => {

        this.setState({
            validateDeviceError: false,
            validateOrderError: false
        })

        if (this.validateForm(true)){
            let user = null;
            if(this.props.auth.isAuthenticated === true){
                user = this.props.auth.user.user;
            }

            let { imei, orderId, purchasedStore, useType, startDate, country, productType, productName, planDays, updatedAt, createdAt } = this.state;
            let payload = {
                imei : imei,
                orderId : orderId,
                purchasedStore : purchasedStore,
                useType : useType,
                startDate : startDate,
                country : country,
                productType : productType,
                productName : productName,
                planDays : planDays,
                user : user,
                createdAt : createdAt,
                updatedAt : updatedAt,
                humanKey: this.state.humanKey
            };

            this.props.addActiveDeviceRequest(payload).then(
                res => {
                    if (res.status){
                        this.setState({
                            requestSubmitted : true
                        })
                        //console.log("Request submitted Successfully")
                    }
                    else {
                        this.showMessage(res.message);

                        this.recaptchaRef.current.reset();
                        this.setState({isHuman: false, humanKey: null});
                    }
                },
                err => {
                    console.log(err);
                    console.log("Request has error : ", err.response.data.message)
                    this.showMessage(err.response.data.message);

                    this.recaptchaRef.current.reset();
                    this.setState({isHuman: false, humanKey: null});
                }
            )


            /*this.props.validateDevice({
                imei : imei,
                orderId : orderId
            }).then(
                res => {
                    if (res.status &&
                        typeof res.device !== "undefined" && typeof res.device._id !== "undefined" &&
                        typeof res.order !== "undefined" && typeof res.order._id !== "undefined"){
                        this.props.addActiveDeviceRequest(payload).then(
                            res => {
                                if (res.status){
                                    this.setState({
                                        requestSubmitted : true
                                    })
                                    console.log("Request submitted Successfully")
                                }
                                else {
                                    this.showMessage(res.message);
                                }
                            },
                            err => {
                                console.log(err);
                                console.log("Request has error : ", err.response.data.message)
                                this.showMessage(err.response.data.message);
                            }
                        )
                    }else{
                        if(typeof res.device == "undefined" || typeof res.device._id == "undefined") {
                            this.setState({
                                validateDeviceError: true
                            })
                        }
                        if(typeof res.order == "undefined" || typeof res.order._id == "undefined") {
                            this.setState({
                                validateOrderError: true
                            })
                        }
                    }
                },
                err => {
                    this.setState({
                        validateDeviceError : true
                    })
                }
            );*/
        }
    };

    _handleLoginCheckout = () => {
        const { auth } = this.props;
        if (auth.isAuthenticated) {
            this.context.router.history.push("/activate");
        }
        this.context.router.history.push("/login");
    };

    confirmMessage = () => {
        let message = '';
        if (this.state.purchasedStore === 'MightyWifi') {
            if (this.state.select === 'NO') {
                if (this.state.productType === 'day_pass') {
                    //message = 'Your device is now activated with ' + (this.state.useType === 'USA' ? 'U.S.' : 'Global') + ' Day Pass for ' + this.state.planDays + ' days starting on ' + this.state.startDate.format("MM/DD/YYYY") + '.';
                    message = 'Your device is now activated with ' + (this.state.useType === 'USA' ? 'U.S.' : this.state.country) + ' Day Pass for ' + this.state.planDays + ' days starting on ' + this.state.startDate.format("MM/DD/YYYY") + '.';
                } else {
                    //message = 'Your device is now activated with ' + this.state.productName + ' ' + (this.state.useType === 'USA' ? 'U.S.' : 'Global') + ' Data for ' + this.state.planDays + ' days starting on ' + this.state.startDate.format("MM/DD/YYYY") + '.';
                    message = 'Your device is now activated with ' + (this.state.useType === 'USA' ? 'U.S.' : this.state.country) + ' ' + this.state.productName + ' Data for ' + this.state.planDays + ' days starting on ' + this.state.startDate.format("MM/DD/YYYY") + '.';
                }
            } else {
                if (this.state.useType === 'USA') {
                    message = 'Your device is now activated with 50GB U.S. Data for 30 days starting on ' + this.state.startDate.format("MM/DD/YYYY") + '.';
                } else {
                    message = 'Your device is now activated with 3GB Global Data for 30 days starting on ' + this.state.startDate.format("MM/DD/YYYY") + '.';
                }
            }
        }
        return message;
    }

    // ReCAPTCHA Client Side
    verifyCaptcha = (res) => {
        if(res) {
            this.setState({ isHuman: true, humanKey: res })
        }
    }

    // ReCAPTCHA Expired
    expireCaptcha = () => {
        this.setState({ isHuman: false, humanKey: null })
    }

    render() {
        var orderIdMask = [];
        if(this.state.purchasedStore == 'Amazon') {
            orderIdMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        }
        else if(this.state.purchasedStore == 'Walmart') {
            orderIdMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        }
        else if(this.state.purchasedStore == 'MightyWifi') {
            orderIdMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        }
        return(
            <section className="BodyContainer">
                <div className="container">
                    <div className="row position-relative">
                        <NotificationAlert ref="notify"/>

                        <div className="col-md-7">
                            <div className="services_content mt-3">
                                <div style={{clear:"both",height:"40px"}}></div>

                                <h2 className="m_Title">For Your {this.state.purchasedStore} Purchase</h2>
                                <div style={{clear:"both",height:"20px"}}></div>
                                {
                                    (this.state.purchasedStore === 'Amazon') ? (
                                        <ul className="custom_ul">
                                            <li><strong>Amazon Order ID:</strong>  See Amazon Order Details or Amazon email confirmation.</li>
                                            <li><strong>IMEI:</strong> The IMEI is found on the back of your device.</li>
                                            <li><strong>Select Data Package:</strong>  US or Global packages</li>
                                            {/* <li><strong>Select Date:</strong> Calendar</li>
                                  <li>Your data will be activated on the selected date.</li> */}
                                        </ul>
                                    ) : null
                                }
                                {
                                    (this.state.purchasedStore === 'Walmart') ? (
                                        <ul className="custom_ul">
                                            <li><strong>Walmart Order ID:</strong>  See Walmart Order Details or Walmart email confirmation.</li>
                                            <li><strong>IMEI:</strong> The IMEI is found on the back of your device.</li>
                                            <li><strong>Select Data Package:</strong>  US or Global packages</li>
                                            {/* <li><strong>Select Date:</strong> Calendar</li>
                                  <li>Your data will be activated on the selected date.</li> */}
                                        </ul>
                                    ) : null
                                }
                                {
                                    (this.state.purchasedStore === 'MightyWifi') ? (
                                        <ul className="custom_ul">
                                            <li><strong>MightyWifi Order ID:</strong>  See MightyWifi Order Details or MightyWifi email confirmation.</li>
                                            <li><strong>IMEI:</strong> The IMEI is found on the back of your device.</li>
                                            <li><strong>Data Package:</strong> The data plan or day passes you purchased / US data for 30 days / Global (ex. the US) data for 30 days.</li>
                                            <li><strong>Start Date:</strong> The first day of your data package. Your data will be activated on this date.</li>
                                        </ul>
                                    ) : null
                                }

                            </div>
                        </div>

                        <div className="col-md-5 sim_services_clip">
                            <div className="services_bg_pad">
                                <div className="row justify-content-center">
                                    <div className="services_boxes">

                                        <div className="services_content mt-5">

                                            {
                                                (this.state.requestSubmitted) ? (
                                                    <div>
                                                        <h2 className="SansSerif">Congratulations!</h2>
                                                        {
                                                            (this.state.purchasedStore === 'Amazon' || this.state.purchasedStore === 'Walmart') ? (
                                                                <div>
                                                                    <p className="margin-top-35">Thank you for
                                                                        purchasing the MightyWifi Hotspot.<br/>
                                                                        Your device is now activated with the chosen
                                                                        data package
                                                                        for {this.state.useType === 'USA' ? '30' : '180'} days.
                                                                    </p>
                                                                    <p>Enjoy your MightyWifi!</p>
                                                                    <p>Don't forget to download the MightyWifi App
                                                                        to keep track of your data usage and to
                                                                        recharge data.<br/>
                                                                        The app is available on Google Play and
                                                                        Apple App Store.</p>
                                                                </div>
                                                            ) : null
                                                        }
                                                        {
                                                            (this.state.purchasedStore === 'MightyWifi') ? (
                                                                <div>
                                                                    <p className="margin-top-35">{this.confirmMessage()}</p>
                                                                    <p>The MightyWifi APP is available for download on Apple App Store and Google Play Store.  We ask you to download the MightyWifi APP to keep track of your data usages and recharge data instantly.</p>
                                                                    <p>Thank you for your business.  Enjoy your MightyWifi!</p>
                                                                </div>
                                                            ) : null
                                                        }
                                                        <Link className="btn btn-white margin-top-35" style={{margin:'30px auto'}} to={{
                                                            pathname: "/dashboard"
                                                        }}>
                                                            My Account
                                                        </Link>

                                                        {/*<a href="javascript:void(0)" className="" onClick={this.saveActiveDeviceRequest}>Continue</a>
                                                            <p className="mb-0 mt-6">
                                                                <h1 style={{marginTop:'40px'}}>&nbsp;</h1>
                                                            </p>*/}

                                                    </div>


                                                ) : null
                                            }

                                            {(!this.state.requestSubmitted) ? (

                                                <div className="text-left col-lg-12 pr-0">

                                                    <div style={{clear:"both",height:"5px"}}></div>

                                                    <h5 className="mb-10">
                                                        Please select where you purchased the MightyWifi?
                                                    </h5>
                                                    <p className="mb-0 mt-2 radio-toolbar">
                                                        <a className={`btn btn-white mr-10` + ((this.state.purchasedStore == 'MightyWifi') ?  ` active` : "")} onClick={ () => this.setPurchasedStore('MightyWifi') } style={{padding: "10px 10px"}}><span style={{fontSize: "0.8em"}}>MightyWifi.net</span></a>
                                                        <a className={`btn btn-white mr-10` + ((this.state.purchasedStore == 'Amazon') ?  ` active` : "")} onClick={ () => this.setPurchasedStore('Amazon') } style={{padding: "10px 10px"}}><span style={{fontSize: "1.0em"}}>Amazon</span></a>
                                                        <a className={`btn btn-white mr-10` + ((this.state.purchasedStore == 'Walmart') ?  ` active` : "")} onClick={ () => this.setPurchasedStore('Walmart') } style={{padding: "10px 10px"}}><span style={{fontSize: "1.0em"}}>Walmart</span></a>
                                                    </p>

                                                    <div style={{clear:"both",height:"30px"}}></div>

                                                    <div>

                                                        <strong>{this.state.purchasedStore} Order ID</strong>
                                                        <p>(From {this.state.purchasedStore} Order Details or {this.state.purchasedStore} email confirmation)</p>
                                                        {/*<input id="order-id" className="form-control no-border-radius order-id-field max-width-300-px" name="orderId" type="text" onChange={this._onChange} required/>*/}
                                                        {/*<InputMask mask="999-9999999-9999999" alwaysShowMask="true" id="order-id" className="form-control no-border-radius order-id-field" name="orderId" type="text" onChange={this._onChange} required />*/}
                                                        <MaskedInput mask={orderIdMask} id="order-id" className="form-control no-border-radius order-id-field" name="orderId" type="text" onChange={this._onChange} required />
                                                        { (this.state.orderIdError) ? (
                                                            <span className="error text-danger">{/*Seller*/}{this.state.purchasedStore} Order ID Required</span>
                                                        ) : null}

                                                        { (this.state.validateOrderError === true) ? (
                                                            <span className="error text-danger">{this.state.purchasedStore} Order not verified.</span>
                                                        ) : null}
                                                    </div>

                                                    <div style={{clear:"both", height:"15px"}}></div>

                                                    <div>
                                                        <strong>IMEI Number</strong>
                                                        <p>(Found on the back of Mightywifi device)</p>
                                                        {/*}<input id="imei" className="form-control no-border-radius sim-card-field max-width-300-px" name="imei" type="text" onChange={this._onChange} required/>*/}
                                                        {/*<InputMask mask="999999999999999" alwaysShowMask="true" id="imei" className="form-control no-border-radius sim-card-field" name="imei" type="text" onChange={this._onChange} required />*/}
                                                        <MaskedInput mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]} id="imei" className="form-control no-border-radius sim-card-field" name="imei" type="text" onChange={this._onChange} required />
                                                        { (this.state.imeiError) ? (
                                                            <span className="error text-danger">IMEI Number Required</span>
                                                        ) : null}

                                                        { (this.state.validateDeviceError === true) ? (
                                                            /*<span className="error text-danger">IMEI Number not verified.</span>*/
                                                            <span className="error text-danger">IMEI not found on the order number. Please enter again.</span>
                                                        ) : null}
                                                    </div>

                                                    {
                                                        (this.state.select === 'NO') ? (

                                                            <div>
                                                                <strong>Data Package</strong>
                                                                <div style={{clear:"both",height:"15px"}}></div>
                                                                <a className={`btn btn-white mr-15 active`}>{ this.state.useType === 'USA' ? this.state.useType + ' ' + this.state.productName : this.state.country + ' ' + this.state.productName }</a>
                                                            </div>

                                                        ) : null
                                                    }

                                                    {
                                                        (this.state.showUseType) ? (

                                                            <div style={{clear:"both",height:"30px"}}></div>

                                                        ) : null
                                                    }

                                                    {
                                                        (this.state.showUseType) ? (

                                                            <div>
                                                                <strong>Data Type</strong><br/>
                                                                <div style={{clear:"both",height:"15px"}}></div>
                                                                { (this.state.showUseType1 === true) ? (
                                                                    <a onClick={() => this.setUseType("USA")} className={`btn btn-white mr-15` + (/*(this.state.useType && this.state.useType == 'ALL') || */(this.state.useType && this.state.useType == 'USA') ?  ` active` : "")}>US Only</a>
                                                                ) : null}

                                                                { (this.state.showUseType2 === true) ? (
                                                                    <a onClick={() => this.setUseType("GLOBAL")} className={`btn btn-white` + (/*(this.state.useType && this.state.useType == 'ALL') || */(this.state.useType && this.state.useType == 'GLOBAL') ?  ` active` : "")}>Global (US excluded)</a>
                                                                ) : null}

                                                                {/* <i className="mdi mdi-help-circle"></i> */}

                                                                {/*<a href="#overlay" id="open-overlay"><u style={{color:"#fff"}}>List of Countries</u></a>

                                                            <div id="overlay" style={{width:"auto",height:"auto",right:"45px"}}>
                                                                <a href="#" className="close">&times;</a>
                                                                <table cellSpacing="0" cellPadding="0" className="country">
                                                                    <tr>
                                                                        <td width="20%" bgcolor="#CCCCCC">Africa</td>
                                                                        <td width="20%" bgcolor="#CCCCCC">Asia</td>
                                                                        <td width="20%" bgcolor="#CCCCCC">Europe</td>
                                                                        <td width="20%" bgcolor="#CCCCCC"></td>
                                                                        <td width="20%" bgcolor="#CCCCCC">Americas</td>
                                                                        <td width="20%" bgcolor="#CCCCCC">Oceania</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%">Egypt</td>
                                                                        <td width="20%">Cambodia</td>
                                                                        <td width="20%">Aland Islands</td>
                                                                        <td width="20%">Lithuania</td>
                                                                        <td width="20%">Argentina</td>
                                                                        <td width="20%">Australia</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%">Morocco</td>
                                                                        <td width="20%">China</td>
                                                                        <td width="20%">Albania</td>
                                                                        <td width="20%">Luxembourg</td>
                                                                        <td width="20%">Canada</td>
                                                                        <td width="20%">Fiji</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%">South Africa</td>
                                                                        <td width="20%">Hong Kong (China)</td>
                                                                        <td width="20%">Austria</td>
                                                                        <td width="20%">Macedonia</td>
                                                                        <td width="20%">Colombia</td>
                                                                        <td width="20%">New Zealand</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">India</td>
                                                                        <td width="20%">Belgium</td>
                                                                        <td width="20%">Malta</td>
                                                                        <td width="20%">French Caribbean</td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Indonesia</td>
                                                                        <td width="20%">Bosnia and Herzegovina</td>
                                                                        <td width="20%">Monaco</td>
                                                                        <td width="20%">Mexico</td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Islamic Republic of Pakistan</td>
                                                                        <td width="20%">Bulgaria</td>
                                                                        <td width="20%">Netherlands</td>
                                                                        <td width="20%">Puerto Rico</td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Israel</td>
                                                                        <td width="20%">Croatia</td>
                                                                        <td width="20%">Norway</td>
                                                                        <td width="20%">United States</td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Japan</td>
                                                                        <td width="20%">Cyprus</td>
                                                                        <td width="20%">Poland</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Jordan</td>
                                                                        <td width="20%">Czech Republic</td>
                                                                        <td width="20%">Portugal</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Laos</td>
                                                                        <td width="20%">Denmark</td>
                                                                        <td width="20%">Reunion</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Macao(China)</td>
                                                                        <td width="20%">Estonia</td>
                                                                        <td width="20%">Romania</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Malaysia</td>
                                                                        <td width="20%">Faroe Islands</td>
                                                                        <td width="20%">Russia</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Myanmar</td>
                                                                        <td width="20%">Finland</td>
                                                                        <td width="20%">San Marino</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Nepal</td>
                                                                        <td width="20%">France</td>
                                                                        <td width="20%">Serbia</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Philippines(Exclude Boracay)</td>
                                                                        <td width="20%">French Guiana</td>
                                                                        <td width="20%">Slovakia</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Qatar</td>
                                                                        <td width="20%">Germany</td>
                                                                        <td width="20%">Slovenia</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Saudi Arabia</td>
                                                                        <td width="20%">Gibraltar</td>
                                                                        <td width="20%">Spain</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Singapore</td>
                                                                        <td width="20%">Greece</td>
                                                                        <td width="20%">Svalbard</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">South Korea</td>
                                                                        <td width="20%">Guernsey</td>
                                                                        <td width="20%">Svalbard and Jan Mayen</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Sri Lanka</td>
                                                                        <td width="20%">Hungary</td>
                                                                        <td width="20%">Sweden</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">State of Kuwait</td>
                                                                        <td width="20%">Iceland</td>
                                                                        <td width="20%">Switzerland</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Sultanate of Oman</td>
                                                                        <td width="20%">Ireland</td>
                                                                        <td width="20%">Turkey</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Taiwan(China)</td>
                                                                        <td width="20%">Isle of Man</td>
                                                                        <td width="20%">United Kingdom</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Thailand</td>
                                                                        <td width="20%">Italy</td>
                                                                        <td width="20%">United States Virgin Islands</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">UAE</td>
                                                                        <td width="20%">Jersey</td>
                                                                        <td width="20%">Vatican</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Vietnam</td>
                                                                        <td width="20%">Latvia</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%">Liechtenstein</td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                        <td width="20%"> </td>
                                                                    </tr>
                                                                </table>
                                                            </div>*/}
                                                                <div style={{clear:"both",height:"0px"}}></div>
                                                                { (this.state.showUseType && this.state.useTypeError) ? (
                                                                    <span className="error text-danger">Data Type Required</span>
                                                                ) : null}
                                                            </div>

                                                        ) : null
                                                    }

                                                    {
                                                        (this.state.showStartDate) ? (

                                                            <div style={{clear:"both",height:"15px"}}></div>

                                                        ) : null
                                                    }

                                                    {
                                                        (this.state.showStartDate) ? (

                                                            <div>
                                                                <strong>Start Date</strong><br/>
                                                                <div style={{clear:"both",height:"15px"}}></div>
                                                                <DatePicker
                                                                    className="form-control data-field"
                                                                    selected={this.state.startDate}
                                                                    minDate={moment()}
                                                                    onChange={this.onStartDateChange}
                                                                    id="startDate"
                                                                    placeholderText="Start Date"
                                                                    onChangeRaw={event => {
                                                                        event.preventDefault();
                                                                    }}
                                                                />
                                                            </div>

                                                        ) : null
                                                    }

                                                    <div style={{clear:"both",height:"30px"}}></div>

                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <ReCAPTCHA
                                                                ref={this.recaptchaRef}
                                                                sitekey={'6LdUIyweAAAAAOs44Nk0ouoOHyz1YlbNMCJuBHfo'}
                                                                // render="explicit"
                                                                onChange={this.verifyCaptcha}
                                                                onExpired={this.expireCaptcha}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div style={{clear:"both",height:"30px"}}></div>

                                                    {
                                                        (this.state.showContinue && this.state.isHuman) ? (

                                                            <a href="javascript:void(0)" className="btn btn-white margin-top-35" onClick={this.validateDevice}>Continue</a>

                                                        ) : null
                                                    }

                                                    {
                                                        (this.state.showActivate && this.state.isHuman) ? (

                                                            <a href="javascript:void(0)" className="btn btn-orange margin-top-35" onClick={this.saveActiveDeviceRequest}>Activate Now</a>

                                                        ) : null
                                                    }

                                                </div>
                                            ) : null}

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


ActiveDeviceRequestController.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
    };
}

export default withRouter(connect(
    mapStateToProps,
    { addActiveDeviceRequest, validateDevice }
)(ActiveDeviceRequestController));



// WEBPACK FOOTER //
// ./src/pages/ActiveDevice/ActiveDeviceRequestController.js